export default __webpack_public_path__ + "static/media/ContactIMG.5c9681ee.png";